import { Input } from 'antd'
import styled from 'styled-components'
import { cssPadding, cssTitle } from 'styles'

export const Title = styled.h2`
  ${cssTitle};
  font-size: 1.4rem;
  font-weight: 600px;
  text-transform: uppercase;
  margin-right: 16px;
  color: var(--color-gray-110);
`

export const Notification = styled.div`
  display: flex;
  align-items: center;
  .avatar-container {
    margin-bottom: 0px;
    margin-left: 12px;
  }
  .ant-badge {
    .ant-avatar {
      background-color: transparent;
      .anticon {
        font-size: 2.4rem;
      }
    }
    .ant-badge-count {
      min-width: 15px;
      height: 15px;
      font-size: 1rem;
      line-height: 15px;
    }
  }
  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper:focus-visible,
  .ant-input-affix-wrapper:focus {
    border-color: var(--color-primary-109);
    box-shadow: 0 0 0 2px var(--color-primary-106);
    outline: none;
  }
  .ant-input-affix-wrapper-focused {
    border-color: var(--color-primary-109);
  }
  .ant-badge-count {
    background-color: var(--color-orange-105);
  }

  .button-icon:hover {
    box-shadow: 0 0 0 2px var(--color-primary-106);
  }
`

export const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  ${Title} {
    + .description {
      margin-left: 16px;
    }
  }
  .description {
    color: ${({ theme }) => theme?.colors?.gray500 || '#737373'};
    font-size: 1.4rem;
    line-height: 1.5;
  }
`

export const HeadWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const HeadContainer = styled.div`
  display: flex;
  height: 65px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  background-color: ${(props) => props.theme?.colors?.white};
  ${cssPadding}
`
export const AvatarWrapperStyled = styled.div`
  margin-left: 16px;
  height: 42px;
  border: 1px solid var(--color-primary-109);
  display: flex;
  align-items: center;
  border-radius: 50px;
  justify-content: space-between;
  cursor: pointer;
  width: fit-content;
  &.ant-dropdown-open {
    svg {
      transform: rotate(180deg);
    }
    .btn-arrow {
      transform: rotate(180deg);
    }
  }
  &:hover {
    background: var(--color-primary-108);
    color: white;
    border: 1px solid white;
    .btn-arrow {
      background: white;
      svg {
        filter: invert(0.5) sepia(1) saturate(5) hue-rotate(175deg);
      }
    }
  }
  .ant-avatar {
    margin-left: 4px;
  }
  .ant-row {
    align-items: center;
  }
`

export const StyledSearchInput = styled(Input)`
  ::hover {
    border-color: var(--color-primary-109);
  }
  width: 250px;
  height: 34px;
`
export const StyledButtonIcon = styled.div`
  margin-left: 12px;
  width: 34px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0px 1px 30px rgba(85, 85, 85, 0.1);
  border-radius: 12px;
`

export const StyledUserName = styled.div`
  font-weight: 600;
  font-size: 1.4rem;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 250px;
  line-height: 16px;
  padding: 0 4px;
`
export const StyledStrong = styled.strong`
  font-size: 1.2rem;
`
export const StyledDegree = styled.div`
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 12px;
  font-size: 1.15rem;
  padding: 0 4px;
`

export const StyleWrapperIconArrow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: var(--color-primary-105);
  border-radius: 50%;
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
`

export const StyleIconArrow = styled.img``

export const StyleMenuItem = styled.span`
  svg {
    margin-right: 8px;
  }
  img {
    margin-right: 4px;
  }
`
